import SvgIcon from '@mui/material/SvgIcon';

const CashInIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M7 15H4C3.73478 15 3.48043 14.8946 3.29289 14.7071C3.10536 14.5196 3 14.2652 3 14V6C3 5.73478 3.10536 5.48043 3.29289 5.29289C3.48043 5.10536 3.73478 5 4 5H16C16.2652 5 16.5196 5.10536 16.7071 5.29289C16.8946 5.48043 17 5.73478 17 6V9"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 19H8C7.73478 19 7.48043 18.8946 7.29289 18.7071C7.10536 18.5196 7 18.2652 7 18V10C7 9.73478 7.10536 9.48043 7.29289 9.29289C7.48043 9.10536 7.73478 9 8 9H20C20.2652 9 20.5196 9.10536 20.7071 9.29289C20.8946 9.48043 21 9.73478 21 10V12.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9198 13.437C15.8218 13.1036 15.6387 12.8015 15.3884 12.5605C15.1381 12.3194 14.8294 12.1477 14.4926 12.0623C14.1558 11.9769 13.8025 11.9807 13.4676 12.0734C13.1327 12.1661 12.8278 12.3444 12.5828 12.5908C12.3378 12.8372 12.1612 13.1431 12.0704 13.4785C11.9797 13.8139 11.9778 14.1672 12.0651 14.5035C12.1524 14.8398 12.3259 15.1476 12.5683 15.3965C12.8108 15.6454 13.1139 15.8268 13.4478 15.923M15.9998 19H21.9998M21.9998 19L18.9998 16M21.9998 19L18.9998 22"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default CashInIcon;
